import { useState, useContext, createContext, useEffect } from "react";

const themeContext = createContext();

export const useThemeContext = () => useContext(themeContext);

export const ThemeProvider = ({ children }) => {
  const [currentMode, setCurrentMode] = useState("Light");

  const setMode = (mode) => {
    setCurrentMode(mode);
    localStorage.setItem("themeMode", mode);
  };

  return (
    <themeContext.Provider
      value={{
        currentMode,
        setMode,
        setCurrentMode,
      }}
    >
      {children}
    </themeContext.Provider>
  );
};
